import { render, staticRenderFns } from "./ViewDetailsModal.vue?vue&type=template&id=4de079aa&"
import script from "./ViewDetailsModal.vue?vue&type=script&lang=js&"
export * from "./ViewDetailsModal.vue?vue&type=script&lang=js&"
import style0 from "./ViewDetailsModal.vue?vue&type=style&index=0&id=4de079aa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports